package one.healthium.domain.paywall

import one.healthium.domain.paywall.models.PaywallSet

class PaywallInteractor(
    private val repository: PaywallRepository,
    private val paywallIdProvider: PaywallIdProvider,
) {
    suspend fun getPaywallSet(): PaywallSet? {
        val paywallSetId = paywallIdProvider.getPaywallId()
        return repository.getPaywallSet(paywallSetId)
    }

    suspend fun getPaywall(id: String) = repository.getPaywall(id)
}